import { IScope } from "@/api";
import { theme } from "@/config/project";
import { useOrganizationProxy } from "@/hooks/useOrganizationProxy";
import { Link, Typography } from "@mui/material";
import { FileSearch2 } from "lucide-react";

interface IProps {
    scope: IScope;
}

export const ScopeLink = ({ scope }: IProps) => {
    const { proxyIntoOrganization, isPending } = useOrganizationProxy({
        navigationPath: `/organizations/scopes/${scope.id}`,
    });

    return (
        <Link
            component="button"
            sx={{
                display: "inline-flex",
                alignItems: "center",
            }}
            onClick={() => proxyIntoOrganization(scope.organization_id)}
            disabled={isPending}
        >
            <FileSearch2 style={{ color: theme.palette.primary.main }} />
            <Typography
                variant="body2"
                sx={{ ml: 1, verticalAlign: "middle" }}
                fontWeight={600}
                color="primary"
            >
                {scope.document_title}
            </Typography>
        </Link>
    );
};
